import { action } from '@ember/object';
import { service } from '@ember/service';
import { isPresent } from '@ember/utils';
import Component from '@glimmer/component';
import type {
  onTaskSavedCallback,
  onTaskSaveErrorArgs,
  onTaskSaveErrorCallback,
  onTaskSavingCallback,
} from 'donor-elf-web/components/task/info';
import V2TaskModel from 'donor-elf-web/models/v2-task';
import TaskService from 'donor-elf-web/services/task-service';

interface ComponentArgs {
  task: V2TaskModel;
  errorSavingTask: boolean;
  showAssignedUsersIfPresent: boolean;
  onTaskSaving: onTaskSavingCallback;
  onTaskSaveError: onTaskSaveErrorCallback;
  onTaskSaved: onTaskSavedCallback;
}

export default class JournalCellStageTaskTriggerComponent extends Component<ComponentArgs> {
  @service declare taskService: TaskService;

  get leftBarColor() {
    if (this.args.errorSavingTask) {
      return 'bg-danger';
    } else if (this.args.task.completedDate) {
      return 'bg-success';
    } else {
      return 'bg-secondary';
    }
  }

  get isOverdue() {
    return this.args.task.dueDate && this.args.task.dueDate < new Date();
  }

  get showAssignedUsers() {
    return (
      this.args.showAssignedUsersIfPresent &&
      isPresent(this.args.task.assignedUserIds)
    );
  }

  get assignedUserLabels() {
    return (this.args.task.assignedUserIds || []).map((userId) => {
      return this.taskService.userLabelsById[userId];
    });
  }

  @action
  handleTaskSaveError(args: onTaskSaveErrorArgs) {
    args.task.rollbackAttributes();
    this.args.onTaskSaveError?.(args);
  }
}
